<template>
  <portal to="destination">
    <ConfirmationModal
      v-if="open"
      :closeable="true"
      @close="open = false"
      :classList="'confirmation-modal'"
      :close-icon-new="true"
      :modal-header-color="true"
      :custom-modal-body="true"
    >
      <div slot="header">
        <span class="combinations-title">{{ $t('BetSlip.Parlays Preview') }}</span>
      </div>
      <div class="confirmation-wrapper custom-confirmation-wrapper" slot="body">
        <div class="rows">
          <div :key="index + 'rr'" v-for="(bet, index) in betList">
            <div class="bet-slip bet-slip-border mb-2">
              <span class="bet-type custom-bet-type custom-text-font">
                {{ getTitle(index) }}
              </span>
              <div class="bet-slip-header light">
                <div class="title" style="margin-bottom: 0 !important">
                  <div class="body">
                    <bet-slip-confirmation-row
                      :bet="bet"
                      :keep-old="true"
                      :custom-confirmation-row="true"
                    ></bet-slip-confirmation-row>
                    <div class="d-flex justify-content-between align-items-center">
                      <strong class="title text-left custom-text-font" style="font-size: 13px"
                        >{{ $t('Risk') }} :
                        <span>{{ currencySymbol }}{{ riskAmount }}</span>
                      </strong>
                      <strong class="title text-right custom-text-font" style="font-size: 14px"
                        >{{ $t('Win') }} : {{ currencySymbol
                        }}{{
                          activeFreeBet
                            ? getWinAmount(bet)
                            : getNotWinAmountNotActiveFreeBet(bet).toFixed(2)
                        }}</strong
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="totalStraight mb-2 mt-2">
            <div class="d-flex justify-content-between" style="padding: 0px 14px">
              <strong class="custom-text-font">{{ $t('BetSlip.Total Bet Amount') }}</strong>
              <strong>{{ currencySymbol }}{{ totalRiskAmount }} </strong>
            </div>
            <div class="d-flex justify-content-between" style="padding: 0px 14px">
              <strong class="custom-text-font">{{ $t('BetSlip.Potential Win Amount') }}</strong>
              <strong>
                {{ totalWinAmount }}
              </strong>
            </div>
          </div>
        </div>
      </div>
    </ConfirmationModal>
  </portal>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BetSlipConfirmationRow from './BetSlipConfirmationRow';
import ConfirmationModal from '@/components/shared/BonusModal';
import { getTranslatedBetType, roundAmount } from './bet-slip-utils';
import BetSlipMixin from '@/views/sports/components/bet-slip/bet-slip-mixin';

export default {
  components: {
    BetSlipConfirmationRow,
    ConfirmationModal,
  },
  props: ['riskAmount', 'betsFromProp', 'bet', 'totalRiskAmount', 'totalWinAmount', 'alternativeTitle', 'parlaySize'],
  mixins: [BetSlipMixin],
  data() {
    return {
      betList: [],
      open: false,
    };
  },
  computed: {
    ...mapState({
      bets: (state) => state.betSlip.bets,
      betOptionsResponse: (state) => state.betSlip.betOptionsResponse,
      activeFreeBet: (state) => state.betSlip.activeFreeBet,
      roundRobins: (state) => state.betSlip.roundRobins,
    }),
    ...mapState('betSlip', ['selectedType']),
    ...mapGetters('player', ['currencySymbol']),
  },
  methods: {
    ...mapActions({
      fillRoundRobinData: 'betSlip/fillRoundRobinData',
    }),
    getTranslatedBetType,
    roundAmount,
    getRiskAmount(bet) {
      if (bet && this.riskAmount) {
        return this.riskAmount;
      }
      return bet ? bet.dgs_risk_amount : '0.00';
    },
    getNotWinAmountNotActiveFreeBet(bet) {
      var amount = parseFloat(parseFloat(this.getWinAmount(bet)) + parseFloat(this.getRiskAmount(bet)));
      if (isNaN(amount)) return 0.00;
      return amount;
    },
    getWinAmount(bet) {
      if (
        bet.Selections.some((item) => {
          return this.roundAmount(this.americanToDecimal(item.Odd)) != '1.91';
        })
      ) {
        let tt = (
          this.riskAmount *
            bet.Selections.reduce((acc, value) => {
              return acc * this.americanToDecimal(value.Odd);
            }, 1) -
          this.riskAmount
        ).toFixed(2);
        return tt;
      } else {
        let total = 0;
        switch (bet.length) {
          case 2:
            total = 2.6;
            break;
          case 3:
            total = 6;
            break;
          case 4:
            total = 12;
            break;
          case 5:
            total = 24;
            break;
          case 6:
            total = 47;
            break;
          case 7:
            total = 91;
            break;
          case 8:
            total = 175;
            break;
          case 9:
            total = 300;
            break;
          case 10:
            total = 600;
            break;
          default:
            return 0;
        }

        return this.riskAmount * total;
      }
    },
    getTitle(index) {
      return getTranslatedBetType(this.alternativeTitle || 'parlay') + ' #' + (index + 1);
    },
    openModal() {
      this.open = true;
    },
  },
  mounted() {
    //console.log(this.betList);
    let rrList = this.roundRobins;
    let previewKey = 'preview_size_' + this.parlaySize;
    let previewObject = {
      key: previewKey,
      parlay_size: this.parlaySize,
      input_risk_amount: this.riskAmount,
      values: this.betsFromProp,
    };
    let checkRR = rrList.filter((a) => a.key == previewObject.key);
    if (checkRR.length == 0) rrList.push(previewObject);
    this.fillRoundRobinData(rrList);
  },
  watch: {
    bet: {
      handler() {
        let rrViewList = [];
        this.betsFromProp.forEach((f) => {
          let newBet = { ...this.bet };
          newBet.input_risk_amount = this.riskAmount;
          newBet.Selections = f;
          rrViewList.push(newBet);
        });
        this.betList = rrViewList;

        // this.betList = this.betsFromProp.map((item) => {
        //   let newBet = this.bet;
        //   newBet.Selections = item;
        //   return {
        //     ...newBet,
        //   };
        // });
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.combinations-title {
  font-size: 14px;
  color: #343a40;
  font-family: Lato;
  font-weight: bold;
  text-transform: uppercase;
}

.bet-slip-border {
  border: 1px solid #f4f4f4;
  box-sizing: border-box;
  border-radius: 3px 3px 0px 0px;
}

.custom-bet-type {
  border-radius: unset !important;
}
.custom-text-font {
  font-size: 13px !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
  @media (min-width: 768px) {
    font-size: 14px !important;
  }
}

.custom-confirmation-wrapper {
  padding: 5px 15px 0px 15px !important;
}
</style>
